var btnFloatingScroll = {
  "btnFloatingScroll": {
    "position": "fixed",
    "right": "2.5rem",
    "bottom": "8.125rem"
  },
  "btnFloatingScroll___a": {
    "backgroundColor": "rgba(0, 0, 0, 0.6)",
    "&:hover": {
      "backgroundColor": "rgba(0, 0, 0, 0.7)"
    },
    "&:active": {
      "backgroundColor": "rgba(0, 0, 0, 0.8)"
    }
  },
  "@media (min-width: 375px)": {
    "btnFloatingScroll": {
      "right": "2.5rem",
      "bottom": "8.125rem"
    }
  },
  "@media (min-width: 768px)": {
    "btnFloatingScroll": {
      "right": "2.5rem",
      "bottom": "8.125rem"
    }
  },
  "@media (min-width: 1024px)": {
    "btnFloatingScroll": {
      "right": "2.5rem",
      "bottom": "8.125rem"
    }
  },
  "@media (min-width: 1280px)": {
    "btnFloatingScroll": {
      "right": "2.5rem",
      "bottom": "8.125rem"
    }
  }
};

export { btnFloatingScroll as default };
